<div class="message-composer">
  <div class="message-composer__content">
    @if (isOpen) {
      <div class="message-composer__editor">
        @if (id == null) {
          <div class="message-composer__editor-header">
            <span>{{ app.text.message.leaveNote }}</span>
          </div>
        }
        <app-field
          [model]="app.message.model"
          [field]="app.fieldId.message.message"
          [labelInside]="true"
          [largeInput]="true"
          [showLabel]="false"
        ></app-field>
      </div>
    }
    <div class="message-composer__add-wrapper">
      @if (!app.message.showSaveButton) {
        <button
          class="btn btn-sm btn-default-blue message-composer__add"
          type="button"
          (click)="app.message.showContent()"
          [disabled]="app.unlockedId != null"
          >
          <i class="fas fa-plus"></i>
          <span>{{ app.text.app.add }}</span>
        </button>
      }
    </div>
    @if (app.message.showSaveButton) {
      <div class="message-composer__actions">
        <button
          class="btn btn-sm btn-clean"
          type="button"
          (click)="cancel()"
          >
          {{ app.text.post.cancel }}
        </button>
        <button
          class="saveBtnRM message-composer__save"
          type="button"
          (click)="save(); app.message.discardChanges()"
          [disabled]="!showSaveButton(id)"
          >
          {{ app.text.app.save }}
        </button>
      </div>
    }
  </div>
</div>
